import { NgClass, NgOptimizedImage, NgStyle } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Slide } from '../../../../../types/builder-components/slideshow';
import { CleanTagsPipe } from '../../../../shared/pipes/clean-tags.pipe';
import { SanitizeContentPipe } from '../../../../shared/pipes/sanitize-content.pipe';

@Component({
  selector: 'app-home-top-slideshow-item',
  standalone: true,
  templateUrl: './home-top-slideshow-item.component.html',
  styleUrls: ['./home-top-slideshow-item.styles.scss'],
  imports: [NgStyle, NgClass, NgOptimizedImage, CleanTagsPipe, SanitizeContentPipe],
})
export class AppHomeTopSlideshowItemComponent implements OnChanges {
  @Input() slide: Slide | undefined;
  defaultImageFit: string = 'cover';
  captionButtonClass: { [key: string]: boolean } = {};
  captionLinkClass: { [key: string]: boolean } = {};

  constructor() {}

  private updateCaptionClasses() {
    this.captionButtonClass = {
      hidden: !!this.slide?.cta?.cta?.hide,
      ['caption-button-' + (this.slide?.cta?.cta?.style?.toLowerCase() || 'light')]: true,
    };
    this.captionLinkClass = {
      hidden: !!this.slide?.cta?.actionLink?.hide,
      ['caption-link-' + (this.slide?.cta?.actionLink?.style?.toLowerCase() || 'light')]: true,
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['slide']) {
      this.updateCaptionClasses();
    }
  }
}
